import { Box, Stack, TextField } from "@mui/material";
import React, { Dispatch, memo, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import FiltersActions from "../../../../components/FiltersActions/FiltersActions";
import useFilter from "../../../../hooks/useFilter";

import { DatePickerUncontrolled, DateRangeSelect } from "@4uhub/lib4uhub";

interface IMacroFilterProps {
  onFilterParams: Dispatch<SetStateAction<IFilterParams>>;
  filterParams: IFilterParams;
}

export interface IFilterParams {
  FirstIntegrationId: string;
  CreatedStart: Date | null;
  CreatedEnd?: Date | null;
  refresh?: boolean;
}

const translationPath = "4uESign.page.logs.forubusSignatureLogs.";

const MacroFilter: React.FC<IMacroFilterProps> = ({
  onFilterParams,
  filterParams,
}) => {
  const { filter, showCleanBtn, initialState, setFilter, cleanFilter } =
    useFilter(filterParams);

  const { t } = useTranslation();

  const filterHandler = () => {
    onFilterParams(filter);
  };

  const [resetDateRange, setResetDateRange] = useState<boolean>(false);
  const cleanHandler = () => {
    onFilterParams(initialState.current);
    cleanFilter();
    setResetDateRange((prev) => !prev);
  };

  const [enableFields, setEnableFields] = useState<boolean>(true);

  const handleStartDate = (date: Date | null) => {
    setFilter({ CreatedStart: date });
  };
  const handleEndDate = (date: Date | null) => {
    setFilter({ CreatedEnd: date });
  };

  return (
    <Stack
      flexDirection={"row"}
      gap={2}
      alignItems="center"
      sx={{ width: "100%" }}
      justifyContent={"space-between"}
    >
      <DateRangeSelect
        setEndDate={handleEndDate}
        setStartDate={handleStartDate}
        setEnableFields={setEnableFields}
        resetToToday={resetDateRange}
      />
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.CreatedStart}
          onChange={(e) => setFilter({ CreatedStart: e })}
          label={`${t(translationPath + "start_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.CreatedEnd}
          onChange={(e) => setFilter({ CreatedEnd: e })}
          label={`${t(translationPath + "end_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>

      <TextField
        value={filter.FirstIntegrationId}
        size="small"
        label={t(translationPath + "first_integration_id")}
        fullWidth
        onChange={(e) => setFilter({ FirstIntegrationId: e.target.value })}
      />

      <FiltersActions
        onFilter={filterHandler}
        onClean={cleanHandler}
        showCleanBtn={showCleanBtn}
      />
    </Stack>
  );
};

export default memo(MacroFilter);
